<template>
    <div class="cont-tit">
        <h2 class="page-title">Technology</h2>
    </div>
    <div class="technology">
        <section class="sec-wrap sec-wrap1">
            <h3 class="sec-tit">“OSE-Commerce Ver.1.2 Platform” system configuration</h3>
            <div class="sec-wrap__top"><img src="@/assets/resource/img/technology-img001.png" alt=""></div>
        </section>

        <section class="sec-wrap sec-wrap2">
            <h3 class="sec-tit">Application of stable element technology</h3>
            <p class="sec-desc">Build a platform based on SPRING FRAMEWORK, define open source to use to implement it</p>
            <div class="sec-wrap__top"><img src="@/assets/resource/img/technology-img003.png" alt=""></div>
        </section>

        <section class="sec-wrap sec-wrap3">
            <h3 class="sec-tit">02. Integrated manager based on stable architecture</h3>
            <p class="sec-desc">Through DB tuning and migration, introduction of standard framework, and use of open source <br>
                Improves the performance and stability of the integrated manager, which is the core of the O2O platform.</p>

            <div class="sec-wrap__top">
                <img src="../../assets/resource/img/differentiation-img002.png" alt="">
            </div>

            <div class="differentiation__sec-box">
                <p>Stable integrated manager renewal using open technology and open source-based S/W tools</p>
            </div>

            <div class="differentiation__sec2-img">
                <img src="../../assets/resource/img/differentiation-img005.png" alt="">
            </div>

            <ul class="text-list">
                <li class="text-item">
                    <p>
                        <b>Safe operating environment</b><br>
                        Compatible Architecture
                    </p>
                </li>
                <li class="text-item">
                    <p>
                        Improved <b>system speed</b> <br>
                        Continuous <b>DB tuning</b>
                    </p>
                </li>
                <li class="text-item">
                    <p>
                        For internal and <br>
                        external linkages <br>
                        <b>standard interface</b>
                    </p>
                </li>
                <li class="text-item">
                    <p>
                        <b>Compliance with web</b> <br>
                        <b>standards and accessibility</b> <br>
                        device independent
                    </p>
                </li>
            </ul>
        </section>

        <!-- <section class="sec-wrap sec-wrap4">
            <h3 class="sec-tit">Cloud Platform (MSA)</h3>
            <p class="sec-desc">Utilizing the AWS cloud platform The cloud platform provides scalability and flexibility, <br>
                and manages infrastructure by utilizing various services of AWS (Amazon EC2, S3, RDS, etc.). Ensures application scalability and stability.</p>
            <div class="sec-wrap__top"><img src="@/assets/resource/img/technology-img03.png" alt=""></div>
        </section> -->

        <section class="sec-wrap sec-wrap5 full">
            <h3 class="sec-tit">Applied technology by area</h3>
            <p class="sec-desc">OSE-Commerce Ver.1.2 builds big data by collecting and analyzing customer product logs, purchases, and shopping cart data. <br>
                Based on this, we provide customized services to customers, such as customized product recommendations and recent route analysis.</p>
            <ul class="sec-wrap__list sec-wrap__top">
                <li class="sec-wrap__item">
                    <h4>front end</h4>
                    <p class="desc">User interface (UI) developed with React and Vue.js. Specialized in fast rendering and improving user experience</p>
                </li>
                <li class="sec-wrap__item">
                    <h4>server side <br>
                        application</h4>
                    <p class="desc">Running server-side applications using Node.js and Spring Boot <br>
                        Supports data exchange between client and server through RESTful API communication</p>
                </li>
                <li class="sec-wrap__item">
                    <h4>user authentication</h4>
                    <p class="desc">Strengthen user authentication and authority management security and access control with JWT (JSON Web Token) and OAuth 2.0</p>
                </li>
                <li class="sec-wrap__item">
                    <h4>database</h4>
                    <p class="desc">MySQL and NoSQL (MongoDB) are used as databases. <br>
                        MySQL is a relational database that stores structured data, MongoDB supports flexible data processing with non-relational (NoSQL)</p>
                </li>
                <li class="sec-wrap__item">
                    <h4>AI chatbot</h4>
                    <p class="desc">Generate responses to user questions and requests using natural language processing (NLP) technology. <br>
                        Learn user behavior patterns through machine learning (ML) and provide responses tailored to the situation.</p>
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
    export default {

    }
</script>
<style>

</style>